import axios from 'axios';
import type { 
  GeolocationData, 
  GeolocationCheckResponse, 
  GeolocationSaveResponse,
  AddressResponse 
} from '../types';

const API_BASE_URL = 'https://tbl.zerdegroup.kz/api/v1/geo';

/**
 * Проверяет наличие геопозиции для пользователя
 */
export async function checkUserGeolocation(username: string): Promise<GeolocationCheckResponse> {
  try {
    const response = await axios.get<GeolocationCheckResponse>(
      `${API_BASE_URL}/check-user-geolocation`,
      { params: { username } }
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при проверке геопозиции:', error);
    throw new Error('Не удалось проверить геопозицию пользователя');
  }
}

/**
 * Сохраняет геопозицию пользователя
 */
export async function saveUserGeolocation(data: GeolocationData): Promise<GeolocationSaveResponse> {
  try {
    const response = await axios.post<GeolocationSaveResponse>(
      `${API_BASE_URL}/save-user-geolocation`,
      data
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при сохранении геопозиции:', error);
    throw new Error('Не удалось сохранить геопозицию');
  }
}

/**
 * Получает адрес по координатам (Reverse Geocoding)
 * Опциональная функция
 */
export async function getAddressByCoords(
  lat: number, 
  lng: number
): Promise<AddressResponse> {
  try {
    const response = await axios.get<AddressResponse>(
      `${API_BASE_URL}/get-address-by-coords`,
      { params: { lat, lng } }
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при получении адреса:', error);
    return { success: false };
  }
}

// ============ QR-КОД ФУНКЦИОНАЛ ============

export interface QRTokenResponse {
  success: boolean;
  token?: string;
  expiresAt?: number;
  ttl?: number;
  message?: string;
}

export interface TokenStatusResponse {
  success: boolean;
  status: 'pending' | 'completed' | 'expired' | 'invalid';
  coordinates?: {
    latitude: number;
    longitude: number;
    accuracy: number;
    address?: string;
  };
  username?: string;
  message?: string;
}

/**
 * Генерирует токен для QR-кода
 */
export async function generateQRToken(username: string): Promise<QRTokenResponse> {
  try {
    const response = await axios.post<QRTokenResponse>(
      `${API_BASE_URL}/generate-qr-token`,
      { username }
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при генерации QR токена:', error);
    throw new Error('Не удалось создать QR-код');
  }
}

/**
 * Проверяет статус токена (для polling)
 */
export async function checkTokenStatus(token: string): Promise<TokenStatusResponse> {
  try {
    const response = await axios.get<TokenStatusResponse>(
      `${API_BASE_URL}/check-token-status/${token}`
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при проверке статуса токена:', error);
    return {
      success: false,
      status: 'invalid',
      message: 'Ошибка проверки статуса'
    };
  }
}

/**
 * Отправляет координаты с мобильного устройства
 */
export async function submitMobileLocation(
  token: string,
  latitude: number,
  longitude: number,
  accuracy: number,
  address?: string,
  guid?: string
): Promise<GeolocationSaveResponse> {
  try {
    const response = await axios.post<GeolocationSaveResponse>(
      `${API_BASE_URL}/submit-mobile-location`,
      { token, latitude, longitude, accuracy, address, guid }
    );
    return response.data;
  } catch (error) {
    console.error('Ошибка при отправке координат:', error);
    throw new Error('Не удалось отправить координаты');
  }
}

